export enum NewslineHubEventTypes {
    UpdateNewsline = "UpdateNewsline"
}
export type NewslineHubEventCallback = (data: unknown) => Promise<void>
export type NewslineHubEvents = Record<NewslineHubEventTypes, NewslineHubEventCallback>
